import {setLocalData} from "../services/StorageServices"
import _checkRoles from "./checkRole"

export function _convertArrayToObject(array, key, value) {
    if (array.length > 0) {
        const obj = array.reduce((acc, curr) => {
            acc[curr[key]] = curr[value]
            return acc
        }, {})

        return obj
    }
}

export function replaceObjectDataCampaign(arr, targetId, newData) {
    return arr.map(obj => {
        if (obj.campaignId === targetId) {
            return {...obj, ...newData}
        }
        return obj
    });
}

export function _convertArray(arr, type) {
    if (type === 'string') {
        return arr.map(number => number.toString())
    } else {
        return arr.map(string => parseInt(string))
    }
}

export function _setLocalDataDialogs(arr) {
    setLocalData('dialogs', arr)
}

export function _setLocalDataTabs(arr) {
    setLocalData('tabs', arr)
}

export function _setLocalDataTabsNotChange(arr) {
    setLocalData('tabsNotChange', arr)
}

export function _setLocalDataTabActive(object) {
    setLocalData('tabActive', object)
}

export function changeLastFourCharacters(inputString, newLastFourCharacters) {
    if (_checkRoles('phone.visible') !== true) {
        if (inputString.length <= 4) {
            return newLastFourCharacters
        } else {
            let originalWithoutLastFour = inputString.substring(0, inputString.length - 4)
            return originalWithoutLastFour + newLastFourCharacters
        }
    } else {
        return inputString
    }
}

export function changeLastFourCharactersResult(inputString, searchString, newLastFourCharacters) {
    const result = searchString.replace(/\D/g, '');
    const regex = new RegExp(`(${result})\\b`)

    if (_checkRoles('phone.visible') !== true) {
        return inputString.replace(regex, (match, captureGroup) => {
            const originalWithoutLastFour = captureGroup.slice(0, -4)

            return originalWithoutLastFour + newLastFourCharacters
        })
    } else {
        return inputString
    }
}

export function calculateSum(array, property) {
    return array.reduce((accumulator, object) => {
        return accumulator + object[property];
    }, 0);
}

export const formatCurrency = (number, local) => {
    return new Intl.NumberFormat(local).format(number);
};